export enum NotificationType {
  Error = 'Error',
  Success = 'Success',
}

export function getNotificationPanelClass(type: NotificationType): string {
  switch (type) {
    case NotificationType.Success:
      return 'notification-success';
    case NotificationType.Error:
      return 'notification-error';
    default:
      return '';
  }
}
